import { createStore } from 'vuex'
import case_records from '@/store/case_record'
import login from '@/store/login'
import next_of_kin from '@/store/next_of_kin'
import read_only_endpoints from '@/store/read_only'
import current_practitioner from '@/store/current_practitioner'
import current_facility from '@/store/current_facility'
import current_resource_provider from '@/store/current_resource_provider'

// no-unused-vars
const store = createStore({
    modules: {
        login: login,
        read_only_endpoints: read_only_endpoints,
        next_of_kin: next_of_kin,
        case_records: case_records,
        current_practitioner: current_practitioner,
        current_facility: current_facility,
        current_resource_provider: current_resource_provider,
    }
})

export default store